<script>
export default {
  computed: {
    //fields array used in setup form
    fields: function () {
      let fields = [
        //PROPERTY TYPE
        [
          {
            type: "header",
            label: "Choose Your Property Type",
            labelClass: this.isSmallScreen
              ? "text-subtitle-1 font-weight-bold mb-1"
              : "text-h6 font-weight-bold mb-7",
            instructions:
              "Guests see content tailored to this property type. Pick the closest match to get started.",
            breakPoint: 800,
          },
          {
            type: "selectPropertyTypes",
            title: "",
            instructions: "",
            options: [
              {
                value: "house",
                label: "House",
                icon: "House@3x.svg",
                selected: this.isSelected("house") ? true : false,
              },
              {
                value: "apartment",
                label: "Apartment",
                icon: "Building@3x.svg",
                selected: this.isSelected("apartment") ? true : false,
              },
              {
                value: "hotel",
                label: "Hotel",
                icon: "Hotel@3x.svg",
                selected: this.isSelected("hotel") ? true : false,
              },
              {
                value: "resort",
                label: "Resort",
                icon: "Resort@3x.svg",
                selected: this.isSelected("resort") ? true : false,
              },
              {
                value: "hostel",
                label: "Hostel",
                icon: "Hostel@3x.svg",
                selected: this.isSelected("hostel") ? true : false,
              },
              {
                value: "camp",
                label: "Camp/Glamp",
                icon: "Camp@3x.svg",
                selected: this.isSelected("camp") ? true : false,
              },
              {
                value: "camper",
                label: "Camper/RV",
                icon: "Camper@3x.svg",
                selected: this.isSelected("camper") ? true : false,
              },
              {
                value: "tourism",
                label: "Tourism",
                icon: "Tourism.svg",
                selected: this.isSelected("tourism") ? true : false,
              },
              {
                value: "attraction",
                label: "Attraction",
                icon: "Attraction.svg",
                selected: this.isSelected("attraction") ? true : false,
              },
              {
                value: "events",
                label: "Events",
                icon: "Events.svg",
                selected: this.isSelected("events") ? true : false,
              },
              {
                value: "hospital",
                label: "Hospital",
                icon: "Hospital@3x.svg",
                selected: this.isSelected("hospital") ? true : false,
              },
              {
                value: "hospitalBrazil",
                label: "Hospital-Brazil",
                icon: "Hospital@3x.svg",
                selected: this.isSelected("hospitalBrazil") ? true : false,
              },
              {
                value: "other",
                label: "Other",
                icon: "Others@3x.svg",
                selected: this.isSelected("other") ? true : false,
              },
            ],
          },
        ],

        //PROPERTY NAME AND IMAGE
        [
          {
            type: "header",
            label: "Property Name & Image",
            instructions:
              "This is how guests recognize your place on the home screen. Keep the name short and memorable.",
          },
          { type: "space" },
          {
            type: "text",
            label: "Property Name",
            key: "name",
            maxCharacters: 26,
            counter: 26,
            required: true,
          },
          { type: "space" },
          {
            type: "switch",
            key: "showName",
            label: "Show Property Name",
            prependLabel: true,
            defaultValue: true,
          },
          { type: "space" },
          {
            type: "header",
            instructions:
              "Turn this off only if your logo already includes the name.",
          },
          {
            type: "space",
          },
          {
            type: "space",
          },
          {
            type: "space",
          },
          {
            type: "imageUpload",
            label: "Upload Property Image or Logo",
            labelClass: "text-h6 mt-15 font-weight-bold",
            key: "avatarImg",
            uploadPath: `/propertyPictures/${Date.now()}avatarImg`,
            circle: true,
            size: { width: 200, height: 200 },
            required: false,
            showInForm: false,
            remove: false,
            confirmRemoveMessage:
              "Are you sure you want to remove this custom logo?",
          },
        ],

        //ADDRESS
        [
          {
            type: "header",
            label: "Property Address",
            instructions:
              "Address powers maps, weather, and nearby places. Guests only see it if you choose to show it.",
          },
          {
            type: "mapsAutocomplete",
            label: "Start typing property's address",
            key: "mapAddress",
          },
          { type: "space" },
          {
            type: "switch",
            key: "showAddress",
            label: "Show Address",
            prependLabel: true,
            defaultValue: true,
          },
          { type: "space" },
          {
            type: "header",
            instructions:
              "Hide the street if you prefer privacy; you can still show a short subtitle.",
          },
          { type: "space", class: "nt-1" },
          {
            type: `${this.showAddress ? "hidden" : "text"}`,
            key: "subtitle",
            maxCharacters: 30,
            maxlength: 30,
            counter: 30,
            label: "<b>Optional</b> - subtitle will replace street name",
          },
          {
            type: "space",
          },
        ],

        //HOST NAME AND IMAGE
        [
          {
            type: "header",
            label: "Host Name and Image",
            instructions:
              "A friendly host name and photo help guests know who to contact.",
          },
          {
            type: "text",
            label: "Host Name",
            key: "contactInfo_hostName",
          },
          { type: "space" },
          {
            type: "imageUpload",
            label: "",
            key: "contactInfo_hostPhotoUrl",
            uploadPath: `/propertyPictures/${Date.now()}hostImg`,
            placeholderIcon: "mid-account-circle",
            circle: true,
            size: { width: 200, height: 200 },
            required: false,
            showInForm: false,
            remove: false,
            confirmRemoveMessage:
              "Are you sure you want to remove this custom logo?",
          },
        ],

        //PLATFORM
        [
          {
            type: "header",
            label: "Platform Messaging",
            instructions:
              "Let guests know which booking platforms you use for messaging.",
          },
          {
            type: "switch",
            label: "Airbnb",
            prependLabel: true,
            noTranslate: true,
            key: "contactInfo_arbnbBool",
            defaultValue: false,
          },
          {
            type: "switch",
            label: "VRBO",
            prependLabel: true,
            noTranslate: true,
            key: "contactInfo_vrboBool",
            defaultValue: false,
          },
          { type: "space" },
        ],

        //HOST CONTACT INFO
        [
          {
            type: "header",
            label: "Host Contact",
            instructions:
              "Optional phone numbers for call or text when guests need help.",
          },
          {
            type: "intPhoneNumber",
            label: "Calling Number",
            key: "contactInfo_callingNumber",
          },
          {
            type: "intPhoneNumber",
            label: "SMS Number",
            key: "contactInfo_smsNumber",
          },
        ],

        //WEATHER SETTING
        [
          {
            type: "header",
            instructions:
              "Guests see local weather in the units you prefer.",
            label: "Weather Setting",
          },
          { type: "space" },
          {
            type: "select",
            label: "Show temperature as:",
            options: [
              {
                text: "Fahrenheit",
                value: "imperial",
              },
              {
                text: "Celsius",
                value: "metric",
              },
            ],
            key: "unit_of_temperature",
          },
        ],

        //BACKGROUND AND WELCOME PAGE
        [
          {
            type: "header",
            label: "Background Theme and Guest Welcome Page",
            instructions:
              "Set the first impression guests see when they open your guide.",
          },
          {
            type: "switch",
            key: "showSplashScreen",
            label: "Show Welcome Page",
            prependLabel: true,
            defaultValue: true,
          },
          { type: "space" },
          { type: "space" },
          {
            type: `${this.showSplashScreen ? "text" : "hidden"}`,
            key: "welcomeText",
            maxCharacters: 40,
            maxlength: 40,
            counter: 40,
            label: '<b>Optional</b> - replaces default Welcome to "City Name".',
          },

          { type: "space" },
          {
            type: "header",
            label: "Background Theme",
            instructions: "Choose a look that matches your property’s vibe.",
            labelClass: "text-h6 font-weight-bold mb-1",
          },
          { type: "space" },
          {
            type: "select",
            label: "Select a Background",
            key: "backgroundColor",
            options: this.bgImages,
          },
        ],

        //GUEST INFO
        [
          {
            type: "header",
            label: "Guest Information Form",
            instructions:
              "Optionally collect name, email, and phone when a guest first opens the guide.",
          },
          { type: "space" },
          {
            type: "select",
            label: "Guest info...",
            options: [
              {
                text: "Do not require guest info. form",
                value: true,
              },
              {
                text: "Require guest info. form on first use",
                value: false,
              },
            ],
            key: "noguestinfo",
          },
        ],

        //BOOK AGAIN
        [
          {
            type: "header",
            label: "Book Again",
            instructions:
              "Add your Airbnb, VRBO, or direct booking link so guests can rebook easily.",
          },
          { type: "space" },
          {
            type: "header",
            instructions: "<strong>No link yet?</strong><br/>Continue and add it later.",
          },
          { type: "space" },
          {
            type: "link",
            label:
              "Book Again Link (must be a valid link, including https:// or http://)",
            key: "bookagain",
          },
        ],

        //QR Code
        [
          {
            type: "header",
            label: "QR Code",
            instructions:
              "Print or share this QR so guests can open your guide on arrival. Publish the guide before displaying it in your listing.",
          },
          { type: "space" },
          {
            type: "slot",
            slotName: "qrcode",
            qrcode: "https://www.easyhostconcierge.com",
          },
        ],

        // FINISH
        [
          {
            type: "header",
            label: "Your guide shell is ready",
            instructions:
              "Starter Property Info and Area Guide pages are in place. Next, personalize that content for your guests.",
          },
        ],
      ];

      return fields;
    },
  },
};
</script>
